<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<ng-container *ngIf="fieldDefinition.reportKey">
    <button class="button-link" (click)="runReportByName({
        name: rowData[fieldDefinition.reportName],
        key: rowData[fieldDefinition.reportKey],
        filter: getFilterParameters(fieldDefinition, rowData)
    })">{{ rowData[fieldDefinition.text] }}</button>
</ng-container>
<ng-container *ngIf="!fieldDefinition.reportKey">
    <button class="button-link" (click)="runReportByName({
        name: rowData[fieldDefinition.reportName],
        key: null,
        filter: getFilterParameters(fieldDefinition, rowData)
    })">{{ rowData[fieldDefinition.text] }}</button>
</ng-container>
